<form>
	<mat-form-field>
		<input matInput name="searchWord" [placeholder]="placeholder" [(ngModel)]="searchWord" (keyup)="keyUp($event)" />
	</mat-form-field>
	<app-checkbox-select
		[subAreasOptions]="renderList"
		[enableScroll]="enableScroll"
		[attrLabel]="attrLabel"
		[checkBoxAll]="checkBoxAll"
		[allSelect]="allSelect"
		(selectEvt)="emit($event)"
		[allPhase]="allPhase"
		[onlyView]="onlyView"
		[hideSelected]="hideSelected"
	></app-checkbox-select>
</form>
